import styles from '../styles/NotFound.module.css'

export default function NotFound(props){
  return(
    <div className={styles.notFoundContainer}>
      <p>The following ingredients were not found in our database:</p>
      <p>{props.list.map((ingredient, idx)=>`${ingredient}${idx === props.list.length-1 ? '' : ','} `)}</p>
    </div>
  )
}
